import { z } from 'zod';
import { NullableIsoDatetimeToDateSchema } from './date-codecs.js';
import { TimelineFetchModeSchema } from './timeline-fetch.js';

export const TimelineDebugFetchTypeSchema = z.enum(['timeline', 'user']);
export type TimelineDebugFetchType = z.infer<typeof TimelineDebugFetchTypeSchema>;

export const TimelineDebugFetchScopeSchema = z.enum(['both', 'home', 'mentions']);
export type TimelineDebugFetchScope = z.infer<typeof TimelineDebugFetchScopeSchema>;

export const TimelineDebugFetchTransportSchema = z.enum(['inngest', 'direct']);
export type TimelineDebugFetchTransport = z.infer<typeof TimelineDebugFetchTransportSchema>;

export const TimelineDebugFetchInputSchema = z.object({
  type: TimelineDebugFetchTypeSchema.default('timeline'),
  forceNew: z.boolean().default(true),
  scope: TimelineDebugFetchScopeSchema.default('both'),
  transport: TimelineDebugFetchTransportSchema.default('inngest'),
  mode: TimelineFetchModeSchema.default('auto'),
  limit: z.number().int().min(1).max(500).default(200),
});

export type TimelineDebugFetchInput = z.infer<typeof TimelineDebugFetchInputSchema>;

export const TimelineDebugSnapshotSchema = z
  .object({
    tweetCount: z.number(),
    updatedAt: NullableIsoDatetimeToDateSchema,
    needsSync: z.boolean(),
    lastBackfillBatch: z.number().nullable().optional(),
  })
  .passthrough()
  .nullable();

export type TimelineDebugSnapshot = z.infer<typeof TimelineDebugSnapshotSchema>;

export const TimelineDebugFetchResponseSchema = z
  .object({
    type: z.string(),
    scope: TimelineDebugFetchScopeSchema.optional(),
    message: z.string().optional(),
    timeline: TimelineDebugSnapshotSchema.optional(),
    mentions: TimelineDebugSnapshotSchema.optional(),
    transport: TimelineDebugFetchTransportSchema.optional(),
    mode: TimelineFetchModeSchema.optional(),
    limit: z.number().optional(),
  })
  .passthrough();

export type TimelineDebugFetchResponse = z.infer<typeof TimelineDebugFetchResponseSchema>;
export type TimelineDebugFetchResponseInput = z.input<typeof TimelineDebugFetchResponseSchema>;

export function parseTimelineDebugFetchResponse(input: TimelineDebugFetchResponseInput): TimelineDebugFetchResponse {
  return TimelineDebugFetchResponseSchema.parse(input);
}
